import config from '@/sheep/config';

let socketTask: UniApp.SocketTask | null = null;
let heartbeatInterval: number | null = null;
let reconnectTimeout: number | null = null;
let isManualClose = false;

const HEARTBEAT_INTERVAL = 30000; // 30s
const RECONNECT_DELAY = 3000; // 3s

export function initWebSocket() {
  const refreshToken = uni.getStorageSync('refresh-token');
  if (!refreshToken) {
    console.log('[WebSocket] 未登录，跳过连接');
    return;
  }
  if (socketTask) {
    // 已有连接，不再重复初始化
    return;
  }

  const wsUrl = (config.baseUrl + config.websocketPath).replace(/^http/, 'ws') + '?token=' + refreshToken;
  console.log('[WebSocket] 连接:', wsUrl);

  isManualClose = false;
  socketTask = uni.connectSocket({
    url: wsUrl,
    success: () => {
      console.log('[WebSocket] connectSocket success');
    },
    fail: (err) => {
      console.error('[WebSocket] connectSocket fail:', err);
      scheduleReconnect();
    }
  });

  socketTask.onOpen(() => {
    console.log('[WebSocket] 连接已打开');
    startHeartbeat();
  });

  socketTask.onMessage((res) => {
    const data = res.data as string;
    if (data === 'pong') {
      return;
    }
    try {
      const jsonMessage = JSON.parse(data);
      const type = jsonMessage.type;
      const content = jsonMessage.content ? JSON.parse(jsonMessage.content) : null;
      if (type === 'notice-push') {
        uni.$emit('notice-push', content);
      } else {
        uni.$emit('websocket-message', { type, content });
      }
    } catch (e) {
      console.error('[WebSocket] 消息解析失败:', data, e);
    }
  });

  socketTask.onClose(() => {
    console.log('[WebSocket] 连接已关闭');
    cleanup();
    if (!isManualClose) {
      scheduleReconnect();
    }
  });

  socketTask.onError((err) => {
    console.error('[WebSocket] 发生错误:', err);
    cleanup();
    if (!isManualClose) {
      scheduleReconnect();
    }
  });
}

export function closeWebSocket() {
  isManualClose = true;
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
    reconnectTimeout = null;
  }
  if (socketTask) {
    socketTask.close({ code: 1000 });
    socketTask = null;
  }
  cleanup();
}

function startHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
  heartbeatInterval = setInterval(() => {
    if (socketTask) {
      socketTask.send({ data: 'ping' });
    }
  }, HEARTBEAT_INTERVAL);
}

function cleanup() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
  socketTask = null;
}

function scheduleReconnect() {
  if (reconnectTimeout) {
    return;
  }
  reconnectTimeout = setTimeout(() => {
    reconnectTimeout = null;
    initWebSocket();
  }, RECONNECT_DELAY);
}
